import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptPeople } from "../adapters/adaptPerson";

interface PeopleFilters {
	regionId?: number;
	areaId?: number;
	storeId?: number;
	archived?: boolean;
	search?: string;
}

const PAGE_SIZE = 100;

const fetchPeople = async (filters: PeopleFilters) => {
	const params: Record<string, unknown> = { page_size: PAGE_SIZE };

	if (filters.regionId !== undefined) params.region = filters.regionId;
	if (filters.areaId !== undefined) params.area = filters.areaId;
	if (filters.storeId !== undefined) params.store = filters.storeId;
	if (filters.archived !== undefined) params.archived = filters.archived;
	if (filters.search !== undefined && filters.search !== "")
		params.search = filters.search;

	const firstResponse = await cmsClient.get<CMSPaginatedData<IRetailUser>>(
		"/homepage/admin/store/user/",
		{ params }
	);

	const allResults = [...firstResponse.data.results];
	let nextUrl = firstResponse.data.next;
	const MAX_PAGES = 50;
	let page = 1;

	while (nextUrl && page < MAX_PAGES) {
		const url = new URL(nextUrl, cmsClient.defaults.baseURL);
		const basePathname = new URL(cmsClient.defaults.baseURL as string).pathname;
		const relativePath = url.pathname.replace(basePathname, "") + url.search;
		const response =
			await cmsClient.get<CMSPaginatedData<IRetailUser>>(relativePath);
		allResults.push(...response.data.results);
		nextUrl = response.data.next;
		page++;
	}

	return allResults;
};

const usePeople = (filters: PeopleFilters = {}) => {
	const query = useQuery(
		[
			"admin-people",
			filters.regionId,
			filters.areaId,
			filters.storeId,
			filters.archived,
			filters.search
		],
		() => fetchPeople(filters),
		{
			select: adaptPeople,
			keepPreviousData: true,
			staleTime: 2 * 60 * 1000
		}
	);

	return query;
};

export default usePeople;
